export default "__VITE_ASSET__BlVNHGsD__"